import { __assign } from "tslib";
import { createExpertToolkitApi, expertToolkitApiUrl } from ".";
import { createHttpTestKit } from "../http/test-kit";
import { createFakeGetResponder, createFakePostResponder } from "../test-utils";
export var createExpertToolkitApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createExpertToolkitApi(fakeHttp);
    var testKit = {
        whenSearchUserAccountsByEmail: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/searchUserAccountsByEmail"))(dto);
        },
        whenGetUserInfo: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/getUserInfo?userId=").concat(dto !== '*' ? dto.userId : '', "&accountId=").concat(dto !== '*' ? dto.accountId : ''));
        },
        whenCheckVpn: function () {
            return createFakeGetResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/checkVpn"));
        },
        whenGetUserEssentials: function (dto) {
            var isDtoObject = typeof dto === 'object';
            return createFakeGetResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/getUserEssentials?accountId=").concat(isDtoObject ? dto.accountId : '', "&userId=").concat(isDtoObject ? dto.userId : '', "&ticketId=").concat(isDtoObject ? dto.ticketId : ''));
        },
        whenGetAccountDetails: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/getUserAccountDetails?accountId=").concat(dto !== '*' ? dto.accountId : '', "&userId=").concat(dto !== '*' ? dto.userId : ''));
        },
        whenGetTicketBrief: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/getTicketBrief?ticketId=").concat(dto !== '*' ? dto.ticketId : '', "&accountId=").concat(dto !== '*' ? dto.accountId : '', "&userId=").concat(dto !== '*' ? dto.userId : ''));
        },
        whenGetUserTicketHistoryStats: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/getUserTicketHistoryStats?ticketId=").concat(dto !== '*' ? dto.ticketId : ''));
        },
        whenGetUserTicketHistory: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/searchUserTicketHistory"))(dto);
        },
        whenGetTicketTechnicalData: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/getTechnicalData?ticketId=").concat(dto !== '*' ? dto.ticketId : ''));
        },
        whenGetUserSites: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/getUserSitesByAccount?userId=").concat(dto !== '*' ? dto.userId : '', "&accountId=").concat(dto !== '*' ? dto.accountId : '', "&searchPhrase=").concat(dto !== '*' ? dto.searchPhrase : ''));
        },
        whenGetSiteBoLinks: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/getSiteBoLinks?userId=").concat(dto !== '*' ? dto.userId : '', "&accountId=").concat(dto !== '*' ? dto.accountId : '', "&metaSiteId=").concat(dto !== '*' ? dto.metaSiteId : ''));
        },
        whenGetSiteData: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/getUserSiteInfo?userId=").concat(dto !== '*' ? dto.userId : '', "&accountId=").concat(dto !== '*' ? dto.accountId : '', "&msid=").concat(dto !== '*' ? dto.siteId : ''));
        },
        whenQueryExpertAssistant: function (dto) {
            var query = dto !== '*' ? encodeURIComponent(dto.query) : '';
            return createFakeGetResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/expertAssistant/query?query=").concat(query, "&userId=").concat(dto !== '*' ? dto.userId : '', "&aiVersion=").concat(dto !== '*' ? dto.aiVersion : ''));
        },
        whenGetInternalRelatedDocs: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/expertAssistant/getInternalRelatedDocs"))(dto);
        },
        whenGetUserDomains: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/userDomains?accountId=").concat(dto !== '*' ? dto.accountId : ''));
        },
        whenGetDomainInfo: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/domainInfo?name=").concat(dto !== '*' ? dto.name : '', "&accountId=").concat(dto !== '*' ? dto.accountId : ''));
        },
        whenGetUserSuccessLockState: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(expertToolkitApiUrl, "/getUserSuccessLockState?accountId=").concat(dto !== '*' ? dto.accountId : '', "&ticketAssignedGroupId=").concat(dto !== '*' ? dto.ticketAssignedGroupId : '', "&ticketChannel=").concat(dto !== '*' ? dto.ticketChannel : ''));
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map